export const UPDATE_QUESTION_SUCCESS = "redux_store:feedbacks.success.update_question";
export const ADD_QUESTION_SUCCESS = "redux_store:feedbacks.success.add_question";
export const DELETE_QUESTION_SUCCESS = "redux_store:feedbacks.success.delete_question";



// WEBPACK FOOTER //
// ./src/successes/feedbacks.js